export const TipiContenuto = {
    COURSE: 'course',
    GROUP_LIVE: 'group_live'
};
